import { Alert, AlertTitle, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { GlobalContext } from 'GlobalContext';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { gettingHiring, inactivatingEmployee } from 'utils/Employees';

const DeactivateEmployee = ({ open, setOpen, reloading, data }) => {
    const { t } = useTranslation();
    const { handlerAlert } = useContext(GlobalContext);

    const [finshDate, setFinshDate] = useState(null);

    const [contracts, setContracts] = useState([]);
    const [selectedContract, setSelectedContract] = useState('');

    const [loadingHiring, setLoadingHiring] = useState(false);
    const [loading, setLoading] = useState(false);
    const [alerts, setAlerts] = useState(false);

    const hasUnsavedChanges = () => {
        return selectedContract !== '' || finshDate !== null;
    };

    const closing = (skipConfirm = false) => {
        if (!skipConfirm && hasUnsavedChanges()) {
            setAlerts(true);
            return;
        }

        setOpen(false);
        setFinshDate(null);
        setContracts([]);
        setSelectedContract('');
        setLoadingHiring(false);
        setLoading(false);
        setAlerts(false);
    };

    //console.log("data", data);

    useEffect(() => {
        if (open) {
            gettingHiring(setLoadingHiring, { employee_id: data?.employee_id, is_active: true }, setContracts);
        }
    }, [data, open]);

    return (
        <>
            <Dialog open={open} onClose={() => closing(false)} maxWidth="sm" fullWidth>
                <DialogTitle
                    sx={{
                        background: (theme) => theme.palette.background.default,
                    }}
                >
                    <Typography variant="body3">{t('timekeeper.employees.dialog.deactivate.title')}</Typography>
                </DialogTitle>

                {alerts && (
                    <Box sx={{ top: 0, zIndex: 10, pb: 1, px: 3, pt: 2 }}>
                        <Alert
                            variant="filled"
                            severity="warning"
                            action={
                                <>
                                    <Button onClick={() => setAlerts(false)} color="inherit" size="small" variant="text" disableElevation>
                                        {t('general.alerts.unsaved_changes.buttons.yes')}
                                    </Button>
                                    <Button onClick={() => closing(true)} color="inherit" size="small" variant="text" disableElevation>
                                        {t('general.alerts.unsaved_changes.buttons.no')}
                                    </Button>
                                </>
                            }
                        >
                            <AlertTitle>{t('general.alerts.unsaved_changes.message')}</AlertTitle>
                        </Alert>
                    </Box>
                )}

                <DialogContent
                    dividers
                    sx={{
                        background: (theme) => theme.palette.background.default,
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid size={6}>
                            <FormControl fullWidth disabled={loadingHiring}>
                                <InputLabel id="hiring-select-label">{t('timekeeper.employees.dialog.assign_position.contract')}</InputLabel>

                                <Select
                                    labelId="hiring-select-label"
                                    required
                                    id="hiring-select"
                                    value={selectedContract}
                                    label={t('timekeeper.employees.dialog.assign_position.contract')}
                                    onChange={(e) => {
                                        setSelectedContract(e.target.value);
                                    }}
                                >
                                    {contracts.map((hiring_rang) => (
                                        <MenuItem value={hiring_rang.hiring_range_id} key={'hiring-select-' + hiring_rang.hiring_range_id}>
                                            {moment(hiring_rang.start_date).format('YYYY-MM-DD')} - {moment(hiring_rang.end_date).format('YYYY-MM-DD')}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid size={6}>
                            <DatePicker
                                label={t('timekeeper.employees.dialog.deactivate.date')}
                                name="date"
                                onChange={(date) => {
                                    setFinshDate(date);
                                }}
                                value={finshDate}
                                slotProps={{
                                    textField: {
                                        required: true,
                                        fullWidth: true,
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions
                    sx={{
                        background: (theme) => theme.palette.background.default,
                    }}
                >
                    <Button variant="outlined" color="error" onClick={() => closing(false)}>
                        {t('timekeeper.employees.dialog.deactivate.buttons.cancel')}
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            inactivatingEmployee(
                                setLoading,
                                selectedContract,
                                {
                                    employee_id: data?.employee_id,
                                    termination_date: finshDate.format('YYYY-MM-DD'),
                                },
                                closing,
                                reloading,
                                handlerAlert,
                                t,
                            );
                        }}
                        loading={loading}
                        disabled={selectedContract === '' || finshDate === null || loading}
                    >
                        {t('timekeeper.employees.dialog.deactivate.buttons.deactivate')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export { DeactivateEmployee };
